import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import {
  Card,
  CardBody,
  Col,
  Form,
  Input,
  Label,
  Row,
  FormFeedback,
} from "reactstrap"
import * as Yup from "yup"
import { useFormik } from "formik"
import isEmpty from "lodash/isEmpty"

// const carparks = [
//   { key: "tampines", title: "Tampines", url: "", entryCode: "", exitCode: "" },
//   { key: "bishan", title: "Bishan", url: "", entryCode: "", exitCode: "" },
//   { key: "jurong", title: "Jurong", url: "", entryCode: "", exitCode: "" },
// ]

const PMSIntegration = ({ onChangeSettings, settings, carParks }) => {
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      username: (settings && settings.username) || "",
      pmsPassword: (settings && settings.pmsPassword) || "",
    },
    validationSchema: Yup.object({
      username: Yup.string().required("Please Enter Value"),
      pmsPassword: Yup.string().required("Please Enter Value"),
    }),
    onSubmit: values => {
      if (values) {
        const modifiedData = { ...settings }
        modifiedData["username"] = values["username"]
        modifiedData["pmsPassword"] = values["pmsPassword"]
        modifiedData["carparkSettings"] = carparkSettings
        onChangeSettings("pmsIntegration", modifiedData)
      }
    },
  })

  const [carparkSettings, setParparkSettings] = useState(carParks)
  const [visible, setVisible] = useState(false)

  // useEffect(() => {
  //   if (carParks) {
  //     setParparkSettings(carParks)
  //   }
  // }, [carParks])

  useEffect(() => {
    if (!isEmpty(settings["carparkSettings"])) {
      let carparkSettings = carParks.map(el => {
        const findIndex = settings["carparkSettings"].findIndex(
          item => item.key == el.key
        )
        if (findIndex > -1) {
          return { ...el, ...settings["carparkSettings"][findIndex] }
        } else {
          return { ...el }
        }
      })
      setParparkSettings(carparkSettings)
    } else {
      setParparkSettings(carParks)
    }
  }, [settings])

  const updateCarparkSetting = (value, key, index) => {
    setParparkSettings(prevState => {
      let newState = [...prevState]
      newState[index][key] = value
      return newState
    })
  }

  const handleVisible = e => {
    setVisible(e)
  }

  return (
    <React.Fragment>
      <Card>
        <CardBody>
          <div className="mb-4 card-title">
            <i className="bx bxs-arrow-to-bottom text-primary align-bottom font-size-24 me-2"></i>
            PMS Integration
          </div>
          <Form
            onSubmit={e => {
              e.preventDefault()
              validation.handleSubmit()
              return false
            }}
          >
            <Row>
              <Col md={6}>
                <div className="mb-3">
                  <Label className="form-label">Username*</Label>
                  <Input
                    name="username"
                    value={validation.values.username || ""}
                    type="text"
                    className="form-control form-control"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    invalid={
                      validation.touched.username && validation.errors.username
                        ? true
                        : false
                    }
                  />
                  {validation.touched.username && validation.errors.username ? (
                    <FormFeedback type="invalid">
                      {validation.errors.username}
                    </FormFeedback>
                  ) : null}
                </div>
              </Col>
              <Col md={6}>
                <div className="mb-3">
                  <Label className="form-label">Password*</Label>
                  <div className="input-group">
                    <Input
                      name="pmsPassword"
                      value={validation.values.pmsPassword || ""}
                      type={visible ? "text" : "password"}
                      className="form-control form-control"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      invalid={
                        validation.touched.pmsPassword &&
                        validation.errors.pmsPassword
                          ? true
                          : false
                      }
                    />
                    <button
                      type="button"
                      id="viw1"
                      className="btn btn-border"
                      style={{
                        border: "1px solid #ced4da",
                        borderLeft: "1px solid #fff",
                      }}
                      onClick={e => {
                        handleVisible(!visible)
                      }}
                    >
                      <i className="mdi mdi-eye"></i>
                    </button>
                  </div>
                  {validation.touched.pmsPassword &&
                  validation.errors.pmsPassword ? (
                    <FormFeedback type="invalid">
                      {validation.errors.pmsPassword}
                    </FormFeedback>
                  ) : null}
                </div>
              </Col>
            </Row>
            <Row>
              <Col md={3}>
                <Label className="form-label">Carpark Title</Label>
              </Col>
              <Col md={5}>
                <Label className="form-label">URL</Label>
              </Col>
              <Col md={2}>
                <Label className="form-label">Entry Code</Label>
              </Col>
              <Col md={2}>
                <Label className="form-label">Exit Code</Label>
              </Col>
            </Row>
            {carparkSettings.map((el, i) => (
              <Row key={el.key}>
                <Col md={3}>
                  <div className="">
                    <Label className="mt-2 mb-0 ms-3">{el.title}</Label>
                  </div>
                </Col>
                <Col md={5}>
                  <div className="mb-3">
                    <Input
                      name={`ke__url_${i}`}
                      type="text"
                      className="form-control form-control"
                      value={el.url}
                      onChange={e =>
                        updateCarparkSetting(e.target.value, "url", i)
                      }
                      onBlur={e =>
                        updateCarparkSetting(e.target.value, "url", i)
                      }
                    />
                  </div>
                </Col>
                <Col md={2}>
                  <div className="mb-3">
                    <Input
                      name={`ke__entrycode_${i}`}
                      type="text"
                      className="form-control form-control"
                      value={el.entryCode}
                      onChange={e =>
                        updateCarparkSetting(e.target.value, "entryCode", i)
                      }
                      onBlur={e =>
                        updateCarparkSetting(e.target.value, "entryCode", i)
                      }
                    />
                  </div>
                </Col>
                <Col md={2}>
                  <div className="mb-3">
                    <Input
                      name={`ke__exitcode_${i}`}
                      type="text"
                      className="form-control form-control"
                      value={el.exitCode}
                      onChange={e =>
                        updateCarparkSetting(e.target.value, "exitCode", i)
                      }
                      onBlur={e =>
                        updateCarparkSetting(e.target.value, "exitCode", i)
                      }
                    />
                  </div>
                </Col>
              </Row>
            ))}
            <div className="mb-3"></div>
            <div>
              <button type="submit" className="btn btn-primary w-md">
                Update
              </button>
            </div>
          </Form>
        </CardBody>
      </Card>
    </React.Fragment>
  )
}

PMSIntegration.propTypes = {
  onChangeSettings: PropTypes.func,
  settings: PropTypes.any,
  carParks: PropTypes.any,
}

export default PMSIntegration
